import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Biberon = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.68 82.2">
  <G fill={color}>
    <Path d="M33.46,26.56v-7.44c0-1.53-1.16-2.78-2.65-2.93-.77-2.72-2.58-5.03-5.07-6.41v-3.44c0-2.26-1.13-4.22-3.1-5.35-2.27-1.31-5.33-1.31-7.6,0-1.97,1.14-3.1,3.09-3.1,5.35v3.44c-2.49,1.38-4.31,3.68-5.07,6.41-1.49.16-2.65,1.4-2.65,2.93v7.44c-2.49,1.18-4.21,3.7-4.21,6.63v38.22c0,5.95,4.84,10.79,10.79,10.79h16.09c5.95,0,10.79-4.84,10.79-10.79v-38.22c0-2.93-1.73-5.46-4.21-6.63ZM15.77,14.56c1.25-.38,2.1-1.53,2.1-2.84v-5.39c0-.09.01-.13.01-.13.05-.08.41-.28.95-.28h0c.55,0,.9.2.95.28,0,0,.01.04.01.13v5.39c0,1.31.85,2.46,2.1,2.84.94.29,1.74.85,2.33,1.59h-10.8c.59-.74,1.39-1.31,2.33-1.59ZM13.81,71.39h-3.26c-1.64,0-2.96-1.33-2.96-2.96s1.33-2.96,2.96-2.96h3.26c1.64,0,2.96,1.33,2.96,2.96s-1.33,2.96-2.96,2.96ZM13.81,61.42h-3.26c-1.64,0-2.96-1.33-2.96-2.96s1.33-2.96,2.96-2.96h3.26c1.64,0,2.96,1.33,2.96,2.96s-1.33,2.96-2.96,2.96ZM13.81,51.45h-3.26c-1.64,0-2.96-1.33-2.96-2.96s1.33-2.96,2.96-2.96h3.26c1.64,0,2.96,1.33,2.96,2.96s-1.33,2.96-2.96,2.96ZM13.81,41.47h-3.26c-1.64,0-2.96-1.33-2.96-2.96s1.33-2.96,2.96-2.96h3.26c1.64,0,2.96,1.33,2.96,2.96s-1.33,2.96-2.96,2.96ZM27.53,25.85H10.14v-3.76h17.39v3.76Z"/>
  </G>
</Svg>
);
};

export default Biberon;
